

//DefaultHost.host 默认值是null,可以在npm run build后面加参数传值,第一个参数即是设置此值。例:yunfengsu.com:3000或192.168.0.12:3000

const config = {}
export default config;

config.invokeFunctionName = 'sendRequest';
config.httpBaseUrl = _=>process.env.VUE_APP_USER_HOST;


config.httpMessages = {
    test:{url:'/api/test',method:'get'},
    CHECK_LOGIN:{url:'/api/checklogin',method:'get'},
    LOGIN:{url:'/api/login',method:'post'},
    WEB_SOCKET_PARAS:{url:'/api/websocket/paras',method:'get'},

    USER_LIST: {url:'/api/admin/user/list',method:'post',timeout: 1200000},
    USER_EDIT: {url:'/api/admin/user/edit',method:'post'},
    USER_CLEAR_PRACTICE_INFO: {url:'/api/admin/user/clear/practice/info',method:'post'},
    USER_CREATE_FIRST_ROOM: {url:'/api/admin/user/create/first',method:'post'},
    PARTNER_LIST: {url:'/api/admin/partner/list',method:'post',timeout: 1200000},
    PARTNER_EDIT: {url:'/api/admin/partner/edit',method:'post'},
    ROOM_LIST: {url:'/api/admin/room/list',method:'post',timeout: 1200000},
    ROOM_EDIT: {url:'/api/admin/room/edit',method:'post'},

    EXPLAIN_CUSTOM_LIST: {url:'/api/admin/explain/custom/list',method:'post',timeout: 1200000},

    LEARN_REPORT_ADD:{url:'/api/admin/learn/report/add',method:'post'},
    LEARN_REPORT_LIST:{url:'/api/admin/learn/report/list',method:'post'},
    PK_LIST:{url:'/api/teach/pk/list',method:'post',timeout:50000},


    PKG_REMOVE: {url:'/api/teach/pk/package/remove',method:'post',timeout: 1200000},
    PKG_UPDATE_STATUS: {url:'/api/teach/pk/package/update/status',method:'post',timeout: 1200000},
    PKG_SAVE: {url:'/api/teach/pk/package/save',method:'post',timeout: 1200000},
    PKG_LIST: {url:'/api/teach/pk/package/list',method:'post',timeout: 1200000},
    PKG_FORMAT: {url:'/api/teach/pk/package/format',method:'post',timeout: 1200000},

    PKG_ATTACH_LIST: {url:'/api/teach/pk/package/attach/list',method:'post',timeout: 1200000},

    PK_SEEKING_HELP_LIST: {url:'/api/admin/pk/seeking/help/list',method:'post',timeout: 1200000},
    PK_SEEKING_UPDATE_SUGGEST_POINTS: {url:'/api/admin/pk/seeking/update/suggest/points',method:'post',timeout: 1200000},

    PK_INFO_PETTY_CHANGE: {url:'/api/teach/pk/petty/change',method:'post',timeout: 1200000},
    PK_QS_PETTY_CHANGE: {url:'/api/teach/pk/qs/petty/change',method:'post',timeout: 1200000},

    PK_SEEKING_HELP: {url:'/api/teach/pk/seeking/help',method:'post',timeout: 1200000},
    PK_SUGGEST_INFO_CHANGE: {url:'/api/teach/pk/suggest/info/change',method:'post',timeout: 1200000},
    PK_SUGGEST_CONCLUSION_UNLOCK: {url:'/api/teach/pk/suggest/unlock/conclusion',method:'post',timeout: 1200000},
    PK_CLEAR_SH_STATUS: {url:'/api/teach/pk/clear/seeking/help/status',method:'post',timeout: 1200000},
    PK_CLEAR_WIN_ABLE: {url:'/api/teach/pk/clear/win/able',method:'post',timeout: 1200000},

    PK_SH_LOG_LIST: {url:'/api/admin/pk/sh/log/list',method:'post',timeout: 1200000},
    PK_ACTIVE_LOG_LIST: {url:'/api/admin/pk/active/log/data',method:'post',timeout: 1200000},
    PK_ACTIVE_LOG_DETAIL: {url:'/api/admin/pk/active/log/detail',method:'post',timeout: 1200000},
    PK_ACTIVE_LOG_PES_INFO_UPDATE: {url:'/api/admin/pk/active/log/pes/update',method:'post',timeout: 1200000},
    PK_FEEDBACK_UPDATE: {url:'/api/pk/feedback/update',method:'post',timeout: 1200000},
    PK_HINT_CONFIG_FOR_USER_UPDATE: {url:'/api/pk/hint/config/for/user/update',method:'post',timeout: 1200000},
    
    PK_EVALUTION_SPEECHCRAFT_ENUM: {url:'/api/admin/pk/evalution/speechcraft/enums',method:'post',timeout: 1200000},
    PK_EVALUTION_SPEECHCRAFT_MODIFY: {url:'/api/admin/pk/evalution/speechcraft/modify',method:'post',timeout: 1200000},

    PK_ACTIVE_LOG_FEEDBACK_LIST: {url:'/api/admin/pk/active/log/feedback/list',method:'post',timeout: 1200000},
    PK_ACTIVE_LOG_FEEDBACK_GUIDER_READED: {url:'/api/admin/pk/active/log/feedback/guider/readed',method:'post',timeout: 1200000},
    PK_SIGN_SH_NODE: {url:'/api/admin/pk/seeking/help/sign',method:'post',timeout: 1200000},


    PK_FINALE_UPDATE: {url:'/api/admin/pk/finale/system/update',method:'post',timeout: 1200000},
    PK_FINALE_LIST: {url:'/api/admin/pk/finale/system/list',method:'post',timeout: 1200000},
    PK_STUDENTS_LIST:{ url:'/api/teach/pk/student/list',method:'post',timeout: 1200000 },
    PK_DETAIL:{ url:'/api/teach/pk/detail',method:'post',timeout: 1200000 },
    PK_FINALE_CREATE_FOR_USER:{ url:'/api/finale/play/begin',method:'post',timeout: 1200000 },
    PK_FINALE_CREATE_FOR_PRACTICE:{url:'/api/teach/pk/finale/create/for/practice',method:'post',timeout: 1200000},
    PK_FINALE_PLAY_SUBMIT:{url:'/api/teach/pk/finale/play/submit',method:'post',timeout: 1200000},
    PK_LEVEL_CONFIG_LIST:{url:'/api/admin/pk/level/config/list',method:'post',timeout: 1200000},
    PK_LEVEL_CONFIG_UPDATE:{url:'/api/admin/pk/level/config/update',method:'post',timeout: 1200000},
    PK_FROZEN:{url:'/api/teach/pk/frozen',method:'post',timeout: 1200000},
    PK_CREATE_WITH_OPTS:{url:'/api/teach/pk/create/with/opts',method:'post',timeout: 1200000},

    PK_CLASSICS_SITUATION_UPDATE:{url:'/api/admin/pk/classics/situation/update',method:'post',timeout: 1200000},
    PK_CLASSICS_SITUATION_LIST:{url:'/api/admin/pk/classics/situation/list',method:'post',timeout: 1200000},
    PK_CLASSICS_SITUATION_PK_INFO:{url:'/api/admin/pk/classics/situation/pk/info',method:'post',timeout: 1200000},
    PK_GET_SUGGEST_INFO:{url:'/api/admin/pk/get/suggest/info',method:'post',timeout: 1200000},

    TASK_CONF_LIST:{url:'/api/admin/task/conf/list',method:'post',timeout: 1200000},
    TASK_CONF_SAVE:{url:'/api/admin/task/conf/save',method:'post',timeout: 1200000},
    TASK_CONF_LOCK:{url:'/api/admin/task/lock',method:'post',timeout: 1200000},
    TASK_USER_START:{url:'/api/admin/task/user/start',method:'post',timeout: 1200000},
    TASK_USER_CLOSE:{url:'/api/admin/task/user/close',method:'post',timeout: 1200000},
    DISCUSS_ROOM_J5T_DATA_GENERATE_BY_CODES:{url:'/api/jt5/data/generate/by/codes',method:'post',timeout: 1200000},
    TASK_USER_CREATE:{url:'/api/admin/task/user/create',method:'post',timeout: 1200000},
    TASK_USER_LIST:{url:'/api/task/user/list',method:'post',timeout: 1200000},
    TASK_USER_RESET_REWARD:{url:'/api/admin/task/reset/reward',method:'post',timeout: 1200000},
    TASK_USER_CHANGE_STEP:{url:'/api/admin/task/change/step',method:'post',timeout: 1200000},

    PVP_ACTIVITY_EDIT:{url:'/api/admin/pvp/activity/edit',method:'post',timeout: 1200000},
    PVP_ACTIVITY_LIST:{url:'/api/admin/pvp/activity/list',method:'post',timeout: 1200000},
    PVP_ROOM_CREATE:{url:'/api/admin/pvp/activity/room/create',method:'post',timeout: 1200000},
    PVP_ROOM_LIST:{url:'/api/admin/pvp/activity/room/list',method:'post',timeout: 1200000},
    PVP_UPDATE_PLAYER_GROUP_INFO:{url:'/api/admin/pvp/update/group/info',method:'post',timeout: 1200000} ,
    PVP_ROOM_CONFIG_GAME:{url:'/api/admin/pvp/activity/room/config/game',method:'post',timeout: 1200000},
    PVP_ROOM_SEAL_UP:{url:'/api/admin/pvp/activity/room/seal/up',method:'post',timeout: 1200000},
    PVP_LIST:{url:'/api/admin/pvp/list',method:'post',timeout: 1200000},
    PVP_RESTART:{url:'/api/admin/pvp/restart',method:'post',timeout: 1200000},
    PVP_CHANGE_PLAYER:{url:'/api/teach/pvp/change/player',method:'post',timeout: 1200000},
    PVP_EVALUATE_EDIT:{url:'/api/admin/pvp/evaluate/edit',method:'post',timeout: 1200000},
    PVP_EVALUATE_SAVE_ANSWER:{url:'/api/admin/llm/training/edit/answer',method:'post',timeout: 12000000},

    PVP_EVALUATE_LIST:{url:'/api/admin/pvp/evaluate/list',method:'post',timeout: 1200000},

    GENERATE_INVITE_CODE:{url:'/api/admin/generate/invite/code',method:'post',timeout: 1200000},

    LTD_LIST_BY_QUERY:{url:'/api/admin/llm/training/list/query',method:'post',timeout:300000},
    LTD_FIND_ASSIGN:{url:'/api/admin/llm/training/find/assign',method:'post',timeout:60000},
    LTD_ASSIGN_TO_USER:{url:'/api/admin/llm/training/assign/user',method:'post',timeout:60000},

    GENERAL_GENERATE_LINE:{url:'/api/general/generate/line',method:'post',timeout:50000},

    LLM_SUPPORT_LIST:{url:'/api/admin/llm/support/list',method:'post',timeout:50000},
    LLM_SUPPORT_UPDATE:{url:'/api/admin/llm/support/update',method:'post',timeout:50000},

    AI_THINK:{url:'/api/ai/general/computed',method:'post',timeout:50000},

    
}


config.onHttpResponse = function (key, data, requestData, response,fullData) {
    if(data.errCode){
        this.notify('GLOBAL_ERROR_INFO',{code:data.errCode,info:data.message});
        throw new Error(data.message);
    }
    const result = data && data.MESSAGE_BODY || data;
    return [result,data]
}
// this.notify('ERROR_INFO',{code:1,info:'xxx'})
// return;